import { WA_WINDOW } from '@ng-web-apis/common';
import {
  Component,
  inject,
  input,
  OnInit,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  TuiButtonOptions,
  TuiDialogContext,
  TuiDialogService,
  TuiButton,
} from '@taiga-ui/core';
import { DeviceDetectorService } from '../../services/device-detector/device-detector.service';
import { PolymorpheusContent } from '@taiga-ui/polymorpheus';
import { take } from 'rxjs';
import { NgClass } from '@angular/common';

@Component({
  selector: 'x-pwa-install-button',
  imports: [TranslatePipe, TuiButton, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './pwa-install-button.component.html',
})
export class PwaInstallButtonComponent implements OnInit {
  $appearance = input<TuiButtonOptions['appearance']>('outline', {
    alias: 'appearance',
  });
  private readonly deviceService = inject(DeviceDetectorService);
  private readonly isIOS = this.deviceService.isIOS;
  private readonly isChromiumBased = this.deviceService.isChromiumBased;
  private readonly dialog = inject(TuiDialogService);
  private readonly window = inject(WA_WINDOW);

  public readonly $showInstallButton = signal(false);
  private deferredPrompt: any = null;

  ngOnInit(): void {
    if (!this.deviceService.isInPwaMode) {
      this.init();
    }
  }

  private init() {
    if (this.isIOS || !this.isChromiumBased) {
      this.$showInstallButton.set(true);
    } else {
      this.window.addEventListener('beforeinstallprompt', (e: Event) => {
        e.preventDefault();
        this.deferredPrompt = e;
        this.$showInstallButton.set(true);
      });
    }
  }

  onInstallPwa(context: PolymorpheusContent<TuiDialogContext>): void {
    if (this.isIOS || !this.isChromiumBased) {
      this.dialog
        .open(context, {
          closable: true,
          dismissible: true,
        })
        .pipe(take(1))
        .subscribe();

      return;
    }

    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.then(() => {
        this.deferredPrompt = null;
        this.$showInstallButton.set(false);
      });
    }
  }
}
